
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/pagination/datatable";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import { Spin, Select } from "antd";

import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { RotateCcw } from "feather-icons-react/build/IconComponents";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import Swal from "sweetalert2";
import { Payroll_API_BASE_URL } from "../PConfig/PConfig";
import {
  Eye,
  Trash2,
  FileText,
  CheckCircle,
  Filter,
  User,
  Briefcase,
  Search,
} from "feather-icons-react/build/IconComponents";

const PayList = () => {
  const [dataLoading, setDataLoading] = useState(false);
  const [receiverType, setReceiverType] = useState("employee");
  const [tokenData, setTokenData] = useState(null);
  const [expensesData, setExpensesData] = useState([]);
  const [superIdData, setSuperIdData] = useState(null);
  const [expenseType, setExpenseType] = useState("");
  const [expenseDate, setExpenseDate] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [amount, setAmount] = useState("");
  const [notes, setNotes] = useState("");
  const [vendorName, setVendorName] = useState("");
  const [vendorCode, setVendorCode] = useState("");
  const [mobile, setMobile] = useState("");
  console.log(setDataLoading, attachment);
  const [selectedPayPeriod, setSelectedPayPeriod] = useState([0]);
  const [branchesList, setBranchesList] = useState([]);
  const [DeptList, setDeptList] = useState([]);
  const [PayPeriodlist, setPayPeriodlist] = useState([]);
  const [vendorLoading, setVendorLoading] = useState(false);
  const [vendorExpensesData, setVendorExpensesData] = useState([]);
  // const [selectedExpense, setSelectedExpense] = useState(null);

  // Table filters
  const [tableBranchId, setTableBranchId] = useState(null);
  const [tableDeptId, setTableDeptId] = useState(null);
  const [tableEmpId, setTableEmpId] = useState(null);
  const [tableFilteredEmployees, setTableFilteredEmployees] = useState([]);

  // Add expense form (offcanvas)
  const [addBranchId, setAddBranchId] = useState(null);
  const [addDeptId, setAddDeptId] = useState(null);
  const [addEmployeeId, setAddEmployeeId] = useState(null);
  const [addFilteredEmployees, setAddFilteredEmployees] = useState([]);
  const [PaidDate, setPaidDate] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
const [selectedExpense, setSelectedExpense] = useState(null);
const [approveMode, setApproveMode] = useState(false);      
const [approvedAmount, setApprovedAmount] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    // const superId = sessionStorage.getItem("superId");
    const superId = sessionStorage.getItem("PayrollSuperId");
    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchBranchsList = async () => {
        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}portal/branch/getbranch?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch Branches");
          }

          const data = await response.json();

          if (data.status) {
            setBranchesList(data.ResultData);
          } else {
            console.error("Invalid Branches response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching BranchesList:", error.message);
        }
      };
      fetchBranchsList();
    }
  }, [superIdData, tokenData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchDeptList = async () => {
        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}portal/department/getdepartment?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch Dept");
          }

          const data = await response.json();

          if (data.status) {
            setDeptList(data.ResultData);
          } else {
            console.error("Invalid Dept response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching DeptList:", error.message);
        }
      };
      fetchDeptList();
    }
  }, [superIdData, tokenData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchPayPeriodsList = async () => {
        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}payroll/payroll/getPayPeriods?SuperId=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch Employees");
          }

          const data = await response.json();

          if (data.status) {
            setPayPeriodlist(data.ResultData);
          } else {
            console.error("Invalid Employees response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching EmployeesList:", error.message);
        }
      };
      fetchPayPeriodsList();
    }
  }, [superIdData, tokenData]);

  useEffect(() => {
    if (!tokenData || !superIdData) return;
    if (receiverType !== "employee") return;

    fetchExpenses();
  }, [
    receiverType,
    tableEmpId,
    tableBranchId,
    selectedPayPeriod,
    tokenData,
    superIdData,
  ]);

  useEffect(() => {
    if (!superIdData) return;

    const fetchTableEmployees = async () => {
      try {
        const branchId = showAdvancedSearch ? tableBranchId : 0;
        const deptId = showAdvancedSearch ? tableDeptId : 0;

        // In advanced search, wait until both selected
        if (showAdvancedSearch && (!branchId || !deptId)) {
          setTableFilteredEmployees([]);
          return;
        }

        const response = await fetch(
          `${Payroll_API_BASE_URL}payroll/payroll/getemployees?superid=${superIdData}&BranchId=${branchId}&DeptId=${deptId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
            },
          }
        );

        const data = await response.json();
        setTableFilteredEmployees(data.status ? data.ResultData : []);
      } catch (error) {
        console.error("Employee fetch error:", error);
        setTableFilteredEmployees([]);
      }
    };

    fetchTableEmployees();
  }, [
    superIdData,
    showAdvancedSearch,
    tableBranchId,
    tableDeptId,
  ]);
  useEffect(() => {
    if (!superIdData) return;

    const fetchAddEmployees = async () => {
      try {
        const response = await fetch(
          `${Payroll_API_BASE_URL}payroll/payroll/getemployees?superid=${superIdData}&BranchId=${addBranchId || 0}&DeptId=${addDeptId || 0}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
            },
          }
        );

        const data = await response.json();
        setAddFilteredEmployees(data.status ? data.ResultData : []);
      } catch {
        setAddFilteredEmployees([]);
      }
    };

    if (superIdData && tokenData) {
      fetchAddEmployees();
    } else {
      setAddFilteredEmployees([]);
    }
  }, [superIdData, addBranchId, addDeptId]);

  useEffect(() => {
    if (!tokenData || !superIdData) return;
    if (receiverType !== "vendor") return;

    fetchVendorExpenses();
  }, [receiverType, selectedPayPeriod, tokenData, superIdData]);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const fetchExpenses = async () => {
    setDataLoading(true);

    try {
      const params = new URLSearchParams({
        SuperId: superIdData,
        RegId: tableEmpId || 0,
        BranchId: tableBranchId || 0,
        PayPeriodId: selectedPayPeriod?.value || 0,
      });

      const response = await fetch(
        `${Payroll_API_BASE_URL}payroll/RegExpenses/getRegExpenses?${params.toString()}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch expenses");

      const result = await response.json();

      if (result.status) {
        const mapped = result.ResultData.map((item) => ({
          id: item.Id,
          employee: item.Name,
          mobile: item.Mobile,
          expenseTypeId: item.ExpenseTypeId,
          expenseDate: item.ExpenseDate,
          amount: item.Amount,
          approvedAmount: item.ApprovedAmount,
          receiver: item.Receiver,
          notes: item.Reason,
          approved: item.Approved,
          filePath: item.FilePath,
          bank: item.Bank,
          accountNo: item.AccountNo,
          PaidDateFm: item.PaidDate,
        }));

        setExpensesData(mapped);
      } else {
        setExpensesData([]);
      }
    } catch (error) {
      console.error("Expense fetch error:", error);
      setExpensesData([]);
    } finally {
      setDataLoading(false);
    }
  };

  const fetchVendorExpenses = async () => {
    setVendorLoading(true);

    try {
      const params = new URLSearchParams({
        SuperId: superIdData
      });

      const response = await fetch(
        `${Payroll_API_BASE_URL}payroll/RegExpenses/getVendorExpenses?${params.toString()}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch vendor expenses");

      const result = await response.json();

      if (result.status) {
        const mapped = result.ResultData.map((item) => ({
          id: item.Id,
          vendorName: item.VendorName,
          mobile: item.Mobile,
          expenseType: item.ExpenseTypeId,
          date: item.ExpenseDate,
          amount: item.Amount,
          isapproved: item.IsApproved,
          notes: item.Notes,
          filePath: item.FilePath,
          PaidDate: item.PaidDate,
          approvedAmount: item.ApprovedAmount,
        }));

        setVendorExpensesData(mapped);
      } else {
        setVendorExpensesData([]);
      }
    } catch (error) {
      console.error("Vendor expense fetch error:", error);
      setVendorExpensesData([]);
    } finally {
      setVendorLoading(false);
    }
  };

  useEffect(() => {
    const offcanvasEl = document.getElementById("offcanvasRightAddPayment");

    const handleOffcanvasClose = () => {
      resetData();
    };

    if (offcanvasEl) {
      offcanvasEl.addEventListener("hidden.bs.offcanvas", handleOffcanvasClose);
    }

    return () => {
      offcanvasEl?.removeEventListener(
        "hidden.bs.offcanvas",
        handleOffcanvasClose
      );
    };
  }, []);


  const resetData = () => {
    // Common fields
    setExpenseType("");
    setExpenseDate("");
    setAmount("");
    setNotes("");
    setAttachment(null);

    // Employee-related
    setAddBranchId(null);
    setAddDeptId(null);
    setAddEmployeeId(null);
    setAddFilteredEmployees([]);

    // Vendor-related
    setVendorName("");
    setVendorCode("");
    setMobile("");

  };


  const handleAddExpense = async (e) => {
    e.preventDefault();

    if (!expenseDate || !amount) {
      Swal.fire("Required", "Please fill all mandatory fields", "warning");
      return;
    }
    setIsSubmitting(true);

    let apiUrl = "";
    const formData = new FormData();

    formData.append("SuperId", superIdData);
    formData.append("ExpenseDate", expenseDate);
    formData.append("Amount", amount);
    formData.append("Notes", notes || "");
    formData.append("CreatedBy", superIdData);
    formData.append("ExpenseTypeId", expenseType);
    formData.append("PaidDate", PaidDate);

    if (attachment) {
      formData.append("Attachment", attachment);
    }

    if (receiverType === "employee") {
      if (!addEmployeeId) {
        Swal.fire("Required", "Please select employee", "warning");
        return;
      }

      apiUrl = `${Payroll_API_BASE_URL}payroll/RegExpenses/AddRegExpenses`;
      formData.append("EmployeeId", addEmployeeId);
    }

    if (receiverType === "vendor") {
      if (!vendorName || !mobile) {
        Swal.fire("Required", "Please fill vendor details", "warning");
        return;
      }

      apiUrl = `${Payroll_API_BASE_URL}payroll/RegExpenses/addVendorExpenses`;
      formData.append("VendorName", vendorName);
      formData.append("VendorCode", vendorCode || "");
      formData.append("Mobile", mobile);
    }

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
        },
        body: formData,
      });

      const result = await response.json();

      if (result.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text:
            receiverType === "employee"
              ? "Employee expense added successfully"
              : "Vendor expense added successfully",
          confirmButtonText: "OK",
        }).then(() => {
          if (receiverType === "employee") {
            fetchExpenses();
          } else {
            fetchVendorExpenses();
          }
          resetData();
          document
            .querySelector("#offcanvasRightAddPayment .btn-close")
            ?.click();
        });
      } else {
        Swal.fire("Error", "Failed to add expense", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong", "error");
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleApproveSubmit = async (expense) => {
  if (!approvedAmount || Number(approvedAmount) <= 0) {
    Swal.fire("Error", "Please enter a valid approved amount", "error");
    return;
  }

  setIsSubmitting(true);

  const isEmployee = !!expense.employee; 

  const apiUrl = isEmployee
    ? `${Payroll_API_BASE_URL}payroll/RegExpenses/ApproveRegExpenses`
    : `${Payroll_API_BASE_URL}payroll/RegExpenses/ApproveVendorExpenses`;

  const payload = isEmployee
    ? { RegExpensesId: expense.id, ApprovedAmount: Number(approvedAmount), UpdatedBy: superIdData }
    : { Id: expense.id, ApprovedAmount: Number(approvedAmount), UpdatedBy: superIdData };

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (result.status) {
      Swal.fire("Success", "Expense approved successfully", "success");
      setApproveMode(false);
      if (isEmployee) fetchExpenses();
      else fetchVendorExpenses();
      document.querySelector("#offcanvasRightViewExpense .btn-close")?.click();
    } else {
      Swal.fire("Error", "Approval failed", "error");
    }
  } catch (error) {
    Swal.fire("Error", "Something went wrong", "error");
  } finally {
    setIsSubmitting(false);
  }
};

  // const tableEmpOptions = tableFilteredEmployees.map((emp) => ({
  //   label: emp.UserName,
  //   value: emp.RegId,
  // }));

  const addEmpOptions = addFilteredEmployees.map((emp) => ({
    label: emp.UserName,
    value: emp.RegId,
  }));

  const BranchesOptions = [
    { label: "All Branches", value: 0 },
    ...branchesList.map((branch) => ({
      label: branch.Name,
      value: branch.branchid,
    })),
  ];
  const addBranchesOptions = [
    ...branchesList.map((branch) => ({
      label: branch.Name,
      value: branch.branchid,
    })),
  ];

  const DeptOptions = [
    { label: "All Dept", value: 0 },
    ...DeptList.map((Dept) => ({
      label: Dept.Name,
      value: Dept.DepartmentId,
    })),
  ];
  const addDeptOptions = [
    ...DeptList.map((Dept) => ({
      label: Dept.Name,
      value: Dept.DepartmentId,
    })),
  ];


  const PayperiodOptions = [
    { label: "All PayPeriods", value: 0 },
    ...PayPeriodlist.map((period) => ({
      label: period.Name,
      value: period.Id,
    })),
  ];

  const handleDownloadFile = (filePath) => {
    if (!filePath) {
      Swal.fire("No File", "No attachment available", "info");
      return;
    }

    const link = document.createElement("a");
    link.href = filePath;
    link.download = filePath.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "employee",
      sorter: (a, b) => (a.employee || "").localeCompare(b.employee || ""),
      render: (text) =>
        text ? (
          <span title={text}>
            {text.length > 15 ? `${text.substring(0, 15)}...` : text}
          </span>
        ) : "N/A",
    },

    {
      title: "Type",
      dataIndex: "expenseTypeId",
      render: (val) => expenseTypes.find((e) => e.id === val)?.name || "N/A",
    },
    {
      title: "Date",
      dataIndex: "expenseDate",
      render: (date) => formatDate(date),
    },
    {
      title: "Amount (₹)",
      dataIndex: "amount",
      sorter: (a, b) => (a.amount || 0) - (b.amount || 0),
      render: (val) =>
        val !== undefined && val !== null
          ? `₹${val.toLocaleString("en-IN")}`
          : "N/A",
    },
  
    {
      title: "Approved (₹)",
      dataIndex: "approvedAmount",
      sorter: (a, b) => (a.approvedAmount || 0) - (b.approvedAmount || 0),
      render: (val) =>
        val !== undefined && val !== null
          ? `₹${val.toLocaleString("en-IN")}`
          : "N/A",
    },
      {
      title: "Paid Date",
      dataIndex: "PaidDate",
      render: (date) => formatDate(date),
    },

    // {
    //   title: "Notes",
    //   dataIndex: "notes",
    //   sorter: (a, b) => (a.notes || "").localeCompare(b.notes || ""),
    //   render: (text) =>
    //     text ? (
    //       <span title={text}>
    //         {text.length > 15 ? `${text.substring(0, 15)}...` : text}
    //       </span>
    //     ) : "N/A",
    // },
    // {
    //   title: "Status",
    //   dataIndex: "approved",
    //   render: (val) => {
    //     if (val === true) {
    //       return <span className="badge bg-success">Approved</span>;
    //     }
    //     if (val === false) {
    //       return <span className="badge bg-warning text-dark">Pending</span>;
    //     }
    //     return "N/A";
    //   },
    // },
       {
  title: "Status",
  dataIndex: "approved",
  key: "approved",
  render: (val) => {
    const statusColors = {
      true: "green",     // Approved
      false: "yellow",   // Pending
    };

    const statusText =
      val === true ? "Approved" :
      val === false ? "Pending" :
      "N/A";

    return (
      <span
        title={statusText}
        style={{
          display: "inline-block",
          width: 12,
          height: 12,
          borderRadius: "50%",
          backgroundColor: statusColors[val] || "gray",
        }}
      />
    );
  },
},
    // {
    //   title: "Action",
    //   dataIndex: "action",
    //   render: (_, row) => (
    //     <div className="action-table-data">
    //       <div className="edit-delete-action">
    //         {/* View */}
    //         <Link
    //           className="me-2 p-2 text-primary"
    //           title="View Details"
    //           data-bs-toggle="offcanvas"
    //           data-bs-target="#offcanvasRightViewExpense"
    //           onClick={() => setSelectedExpense(row)}
    //         >
    //           <Eye className="feather-view" />
    //         </Link>

    //         {/* View Files */}
    //         <Link
    //           className={`me-2 p-2 ${row.filePath ? "text-info" : "text-secondary"}`}
    //           title={row.filePath ? "Download File" : "No File"}
    //           style={{
    //             pointerEvents: row.filePath ? "auto" : "none",
    //             opacity: row.filePath ? 1 : 0.5,
    //           }}
    //           onClick={() => handleDownloadFile(row.filePath)}
    //         >
    //           <FileText className="feather-file" />
    //         </Link>

    //         <Link
    //           className={`me-2 p-2 ${row.approved ? "text-secondary disabled" : "text-success"}`}
    //           title={row.approved ? "Already Approved" : "Approve"}
    //           style={{
    //             pointerEvents: row.approved ? "none" : "auto",
    //             opacity: row.approved ? 0.5 : 1,
    //           }}
    //           onClick={() => handleApproveEmployeeExpense(row)}
    //         >
    //           <CheckCircle className="feather-approve" />
    //         </Link>

    //         <Link
    //           className={`confirm-text p-2 ${row.approved ? "text-secondary disabled" : "text-danger"}`}
    //           title={row.approved ? "Cannot delete approved expense" : "Delete"}
    //           style={{
    //             pointerEvents: row.approved ? "none" : "auto",
    //             opacity: row.approved ? 0.5 : 1,
    //           }}
    //           onClick={() => handleDeleteEmployeeExpense(row)}
    //         >
    //           <Trash2 className="feather-trash-2" />
    //         </Link>
    //       </div>
    //     </div>
    //   ),
    // },
    {
  title: "Action",
  dataIndex: "action",
  render: (_, row) => {
    const isApproved = row.approved === true;

    return (
      <div className="action-table-data">
        <div className="edit-delete-action">
          <Link
            className={`me-2 p-2 ${isApproved ? "text-primary" : "text-success"}`}
            title={isApproved ? "View Details" : "Approve Expense"}
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasRightViewExpense"
            onClick={() => {
              setSelectedExpense(row);
              setApproveMode(!isApproved);
              setApprovedAmount(isApproved ? (row.approvedAmount || row.amount || "") : "");
            }}
          >
            {isApproved ? <Eye /> : <CheckCircle />}
          </Link>

          <Link
            className={`me-2 p-2 ${row.filePath ? "text-info" : "text-secondary"}`}
            title={row.filePath ? "Download File" : "No File"}
            style={{ pointerEvents: row.filePath ? "auto" : "none", opacity: row.filePath ? 1 : 0.5 }}
            onClick={() => handleDownloadFile(row.filePath)}
          >
            <FileText className="feather-file" />
          </Link>

          <Link
            className={`confirm-text p-2 ${isApproved ? "text-secondary disabled" : "text-danger"}`}
            title={isApproved ? "Cannot delete approved expense" : "Delete"}
            style={{ pointerEvents: isApproved ? "none" : "auto", opacity: isApproved ? 0.5 : 1 }}
            onClick={() => handleDeleteEmployeeExpense(row)}
          >
            <Trash2 className="feather-trash-2" />
          </Link>
        </div>
      </div>
    );
  },
},
  ];

  const Vendorcolumns = [
    {
      title: "Name",
      dataIndex: "vendorName",
      sorter: (a, b) => (a.vendorName || "").localeCompare(b.vendorName || ""),
      render: (text) =>
        text ? (
          <span title={text}>
            {text.length > 15 ? `${text.substring(0, 15)}...` : text}
          </span>
        ) : "N/A",
    },

    {
      title: "Type",
      dataIndex: "expenseType",
      render: (val) => expenseTypes.find((e) => e.id === val)?.name || "N/A",
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (date) => formatDate(date),
    },
    {
      title: "Amount (₹)",
      dataIndex: "amount",
      sorter: (a, b) => (a.amount || 0) - (b.amount || 0),
      render: (val) =>
        val !== undefined && val !== null
          ? `₹${val.toLocaleString("en-IN")}`
          : "N/A",
    },
    // {
    //   title: "Mobile",
    //   dataIndex: "mobile",
    //   sorter: (a, b) => (a.mobile || "").localeCompare(b.mobile || ""),
    //   render: (text) => text || "N/A",
    // },
        {
      title: "Approved (₹)",
      dataIndex: "approvedAmount",
      sorter: (a, b) => (a.approvedAmount || 0) - (b.approvedAmount || 0),
      render: (val) =>
        val !== undefined && val !== null
          ? `₹${val.toLocaleString("en-IN")}`
          : "N/A",
    },
    {
      title: "Paid Date",
      dataIndex: "PaidDate",
      render: (date) => formatDate(date),
    },
    // {
    //   title: "Notes",
    //   dataIndex: "notes",
    //   render: (text) =>
    //     text ? (
    //       <span title={text}>
    //         {text.length > 15 ? `${text.substring(0, 15)}...` : text}
    //       </span>
    //     ) : "N/A",
    // },
    // {
    //   title: "Status",
    //   dataIndex: "isapproved",
    //   render: (val) => {
    //     if (val === true) {
    //       return <span className="badge bg-success">Approved</span>;
    //     }
    //     if (val === false) {
    //       return <span className="badge bg-warning text-dark">Pending</span>;
    //     }
    //     return "N/A";
    //   },
    // },

   {
  title: "Status",
  dataIndex: "isapproved",
  key: "isapproved",
  render: (val) => {
    const statusColors = {
      true: "green",     // Approved
      false: "yellow",   // Pending
    };

    const statusText =
      val === true ? "Approved" :
      val === false ? "Pending" :
      "N/A";

    return (
      <span
        title={statusText}
        style={{
          display: "inline-block",
          width: 12,
          height: 12,
          borderRadius: "50%",
          backgroundColor: statusColors[val] || "gray",
        }}
      />
    );
  },
},
    // {
    //   title: "Action",
    //   dataIndex: "action",
    //   render: (_, row) => (
    //     <div className="action-table-data">
    //       <div className="edit-delete-action">
    //         {/* View */}
    //         {/* <Link
    //           className="me-2 p-2 text-primary"
    //           title="View Details"
    //           data-bs-toggle="offcanvas"
    //           data-bs-target="#offcanvasRightViewExpense"
    //           onClick={() => setSelectedExpense(row)}
    //         >
    //           <Eye className="feather-view" />
    //         </Link> */}

    //         {/* View Files */}
    //         <Link
    //           className={`me-2 p-2 ${row.filePath ? "text-info" : "text-secondary"}`}
    //           title={row.filePath ? "Download File" : "No File"}
    //           style={{
    //             pointerEvents: row.filePath ? "auto" : "none",
    //             opacity: row.filePath ? 1 : 0.5,
    //           }}
    //           onClick={() => handleDownloadFile(row.filePath)}
    //         >
    //           <FileText className="feather-file" />
    //         </Link>

    //         <Link
    //           className={`me-2 p-2 ${row.isapproved ? "text-secondary disabled" : "text-success"}`}
    //           title={row.isapproved ? "Already Approved" : "Approve"}
    //           style={{
    //             pointerEvents: row.isapproved ? "none" : "auto",
    //             opacity: row.isapproved ? 0.5 : 1,
    //           }}
    //           onClick={() => handleApproveVendorExpense(row)}
    //         >
    //           <CheckCircle className="feather-approve" />
    //         </Link>

    //         <Link
    //           className={`confirm-text p-2 ${row.isapproved ? "text-secondary disabled" : "text-danger"}`}
    //           title={row.isapproved ? "Cannot delete approved expense" : "Delete"}
    //           style={{
    //             pointerEvents: row.isapproved ? "none" : "auto",
    //             opacity: row.isapproved ? 0.5 : 1,
    //           }}
    //           onClick={() => handleDeleteVendorExpense(row)}
    //         >
    //           <Trash2 className="feather-trash-2" />
    //         </Link>
    //       </div>
    //     </div>
    //   ),
    // },
    {
  title: "Action",
  dataIndex: "action",
  render: (_, row) => {
    const isApproved = row.isapproved === true;

    return (
      <div className="action-table-data">
        <div className="edit-delete-action">
          <Link
            className={`me-2 p-2 ${isApproved ? "text-primary" : "text-success"}`}
            title={isApproved ? "View Details" : "Approve Expense"}
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasRightViewExpense"
            onClick={() => {
              setSelectedExpense(row);
              setApproveMode(!isApproved);
              setApprovedAmount(isApproved ? (row.approvedAmount || row.amount || "") : "");
            }}
          >
            {isApproved ? <Eye /> : <CheckCircle />}
          </Link>

          <Link
            className={`me-2 p-2 ${row.filePath ? "text-info" : "text-secondary"}`}
            title={row.filePath ? "Download File" : "No File"}
            style={{ pointerEvents: row.filePath ? "auto" : "none", opacity: row.filePath ? 1 : 0.5 }}
            onClick={() => handleDownloadFile(row.filePath)}
          >
            <FileText className="feather-file" />
          </Link>

          <Link
            className={`confirm-text p-2 ${isApproved ? "text-secondary disabled" : "text-danger"}`}
            title={isApproved ? "Cannot delete approved expense" : "Delete"}
            style={{ pointerEvents: isApproved ? "none" : "auto", opacity: isApproved ? 0.5 : 1 }}
            onClick={() => handleDeleteVendorExpense(row)}
          >
            <Trash2 className="feather-trash-2" />
          </Link>
        </div>
      </div>
    );
  },
},
  ];

  const handleReload = () => {
    window.location.reload();
  };

  // const handleApproveEmployeeExpense = async (row) => {
  //   if (row.approved) return;

  //   try {
  //     const response = await fetch(
  //       `${Payroll_API_BASE_URL}payroll/RegExpenses/ApproveRegExpenses`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
  //         },
  //         body: JSON.stringify({
  //           RegExpensesId: row.id,
  //           UpdatedBy: superIdData,
  //         }),
  //       }
  //     );

  //     const result = await response.json();

  //     if (result.status) {
  //       Swal.fire({
  //         icon: "success",
  //         title: "Approved",
  //         text: "Expense approved successfully",
  //         confirmButtonText: "OK",
  //       });

  //       fetchExpenses();
  //     } else {
  //       Swal.fire("Error", "Approval failed", "error");
  //     }
  //   } catch (error) {
  //     Swal.fire("Error", "Something went wrong", "error");
  //   }
  // };

  const handleDeleteEmployeeExpense = async (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This expense will be permanently deleted",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      try {
        const response = await fetch(
          `${Payroll_API_BASE_URL}payroll/RegExpenses/DeleteRegExpenses`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
            },
            body: JSON.stringify({
              RegExpensesId: row.id,
              UpdatedBy: superIdData,
            }),
          }
        );

        const resultData = await response.json();

        if (resultData.status) {
          Swal.fire({
            icon: "success",
            title: "Deleted",
            text: "Expense deleted successfully",
            confirmButtonText: "OK",
          });

          // Refresh list
          fetchExpenses();
        } else {
          Swal.fire("Error", "Delete failed", "error");
        }
      } catch (error) {
        console.log("Error", "Something went wrong", "error");
      }
    });
  };
  // const handleApproveVendorExpense = async (row) => {
  //   if (row.approved) return;

  //   try {
  //     const response = await fetch(
  //       `${Payroll_API_BASE_URL}payroll/RegExpenses/ApproveVendorExpenses`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
  //         },
  //         body: JSON.stringify({
  //           Id: row.id,
  //           UpdatedBy: superIdData,
  //         }),
  //       }
  //     );

  //     const result = await response.json();

  //     if (result.status) {
  //       Swal.fire({
  //         icon: "success",
  //         title: "Approved",
  //         text: "Expense approved successfully",
  //         confirmButtonText: "OK",
  //       });

  //       fetchVendorExpenses();
  //     } else {
  //       Swal.fire("Error", "Approval failed", "error");
  //     }
  //   } catch (error) {
  //     Swal.fire("Error", "Something went wrong", "error");
  //   }
  // };

  const handleDeleteVendorExpense = async (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This expense will be permanently deleted",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      try {
        const response = await fetch(
          `${Payroll_API_BASE_URL}payroll/RegExpenses/deleteVendorExpenses`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
            },
            body: JSON.stringify({
              Id: row.id,
              UpdatedBy: superIdData,
            }),
          }
        );

        const resultData = await response.json();

        if (resultData.status) {
          Swal.fire({
            icon: "success",
            title: "Deleted",
            text: "Expense deleted successfully",
            confirmButtonText: "OK",
          });

          // Refresh list
          fetchVendorExpenses();
        } else {
          Swal.fire("Error", "Delete failed", "error");
        }
      } catch (error) {
        Swal.fire("Error", "Something went wrong", "error");
      }
    });
  };

  const handleDownloadExcel = () => {
    if (expensesData.length === 0) return;

    const wb = XLSX.utils.book_new();
    const wsData = expensesData.map((item, index) => ({
      "S.No": index + 1,
      Employee: item.employee,
      "Emp Code": item.empCode,
      "Monthly Salary": item.monthlySalary,
      "Yearly CTC": item.yearlyCTC,
      Group: item.group,
      "Start Date": formatDate(item.startDate),
      "End Date": formatDate(item.endDate),
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Annual CTC");
    XLSX.writeFile(wb, "Employee_Annual_CTC.xlsx");
  };

  const generatePDF = () => {
    if (expensesData.length === 0) return;

    const doc = new jsPDF();
    doc.text("Employee Annual CTC Report", 14, 10);

    const tableColumn = [
      "S.No",
      "Employee",
      "Emp Code",
      "Monthly Salary",
      "Yearly CTC",
      "Group",
      "Start Date",
      "End Date",
    ];
    const tableRows = expensesData.map((item, index) => [
      index + 1,
      item.employee,
      item.empCode,
      `$${item.monthlySalary.toLocaleString()}`,
      `$${item.yearlyCTC.toLocaleString()}`,
      `$${item.group.toLocaleString()}`,
      formatDate(item.startDate),
      formatDate(item.endDate),
    ]);

    doc.autoTable({ head: [tableColumn], body: tableRows, startY: 20 });
    doc.save("Employee_Annual_CTC.pdf");
  };

  const expenseTypes = [
    { id: 1, name: "Utilities" },
    { id: 2, name: "Internet & Phone" },
    { id: 3, name: "Office Supplies" },
    { id: 4, name: "Office Equipment" },
    { id: 5, name: "Maintenance & Cleaning" },
    { id: 6, name: "Office Equipment" },
    { id: 7, name: "Transportation" },
    { id: 8, name: "Professional Fees" },
    { id: 9, name: "Other Expenses" },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header m-2">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Expenses Receivers
                    </h4>
                  </ol>
                </nav>
                <h6>Manage your Expenses Receivers List</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <div className="btn-group" role="group">
                  <input
                    type="radio"
                    className="btn-check"
                    name="btnradio"
                    id="btnradio1"
                    checked={receiverType === "employee"}
                    onChange={() => setReceiverType("employee")}
                  />
                  <label className="btn btn-outline-primary" htmlFor="btnradio1">
                    <User size={16} className="me-1 mb-1" />
                    Employee
                  </label>

                  <input
                    type="radio"
                    className="btn-check"
                    name="btnradio"
                    id="btnradio2"
                    checked={receiverType === "vendor"}
                    onChange={() => setReceiverType("vendor")}
                  />
                  <label className="btn btn-outline-primary" htmlFor="btnradio2">
                    <Briefcase size={16} className="me-1 mb-1" />
                    Vendor
                  </label>
                </div>
              </li>
              <li>
                <Link onClick={generatePDF}>
                  <ImageWithBasePath
                    src="assets/img/icons/pdf.svg"
                    alt="PDF"
                  />
                </Link>
              </li>
              <li>
                <Link onClick={handleDownloadExcel}>
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="Excel"
                  />
                </Link>
              </li>
              <li onClick={handleReload}>
                <Link>
                  <RotateCcw />
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-success"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightAddPayment"
                  aria-controls="offcanvasRightAddPayment"
                >
                  <i className="ti ti-circle-plus fs-4"></i>
                </Link>
              </li>
            </ul>
          </div>
          {receiverType === "employee" && (
            <div className="card table-list-card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3 p-1">
                <div className="search-set"></div>
                <div className="d-flex right-content align-items-end ">
                  <div className="dropdown me-2 pt-3">
                    <div className="input-blocks">
                      <i data-feather="grid" className="info-img" />
                      <Select
                        showSearch
                        labelInValue
                        placeholder="Select PayPeriod"
                        value={selectedPayPeriod}
                        onChange={(option) => setSelectedPayPeriod(option)}
                        options={PayperiodOptions}
                        style={{ width: 170, height: 37 }}
                        filterOption={(input, option) =>
                          option?.label?.toLowerCase().includes(input.toLowerCase())
                        }
                      />
                    </div>
                  </div>
                  {/* Branch & Dept (Advanced Search Only) */}
                  {showAdvancedSearch && (
                    <>
                      <div className="dropdown me-2 pt-3">
                        <div className="input-blocks">
                          <i data-feather="check-circle" className="info-img" />
                          <Select
                            showSearch
                            placeholder="Select Branch"
                            value={tableBranchId}
                            onChange={(val) => setTableBranchId(val)}
                            options={BranchesOptions}
                            style={{ width: 170, height: 37 }}
                            filterOption={(input, option) =>
                              option?.label?.toLowerCase().includes(input.toLowerCase())
                            }
                          />
                        </div>
                      </div>

                      <div className="dropdown me-2 pt-3">
                        <div className="input-blocks">
                          <i data-feather="check-circle" className="info-img" />
                          <Select
                            showSearch
                            placeholder="Select Dept"
                            value={tableDeptId}
                            onChange={(val) => setTableDeptId(val)}
                            options={DeptOptions}
                            style={{ width: 170, height: 37 }}
                            filterOption={(input, option) =>
                              option?.label?.toLowerCase().includes(input.toLowerCase())
                            }
                          />
                        </div>
                      </div>
                    </>
                  )}

                  {/* Employee Dropdown (Always Visible) */}
                  <div className="dropdown me-2 pt-3">
                    <div className="input-blocks">
                      <i data-feather="check-circle" className="info-img" />
                      <Select
                        showSearch
                        placeholder="Select Employee"
                        value={tableEmpId}
                        onChange={(val) => setTableEmpId(val)}
                        options={[
                          { label: "All Employees", value: 0 },
                          ...tableFilteredEmployees.map((emp) => ({
                            label: emp.UserWithBadge,
                            value: emp.RegId,
                          })),
                        ]}
                        style={{ width: 200, height: 37 }}
                        optionFilterProp="label"
                        virtual={false}
                      />
                    </div>
                  </div>
                  <div className="dropdown me-2 pt-3">
                    <div className="input-blocks">
                      <i data-feather="check-circle" className="info-img" />
                      <button
                        type="button"
                        className={`btn btn-outline-primary d-flex align-items-center justify-content-center ${showAdvancedSearch ? "active" : ""
                          }`}
                        onClick={() => {
                          setShowAdvancedSearch((prev) => !prev);
                          setTableBranchId(0);
                          setTableDeptId(0);
                          setTableEmpId(0);
                        }}
                        title={showAdvancedSearch ? "Close Advanced Search" : "Open Advanced Search"}
                        style={{ width: 38, height: 38 }}
                      >
                        {showAdvancedSearch ? (
                        <Search
                          size={26}
                          style={{ transform: "scale(1.7)" }}
                        />
                      ) : (
                        <Filter
                          size={26}
                          style={{ transform: "scale(1.7)" }}
                        />
                      )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive brand-table">
                  {dataLoading ? (
                    <div className="text-center my-4">
                      <Spin size="large" />
                      <p>Loading data...</p>
                    </div>
                  ) : (
                    <Table
                      columns={columns}
                      pgno={true}
                      dataSource={expensesData}
                      rowKey="key"
                    />
                  )}
                </div>
              </div>
            </div>
          )}
          {receiverType === "vendor" && (
            <div className="card table-list-card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3 p-1">
                <div className="search-set"></div>
                <div className="d-flex right-content align-items-end ">
                  <div className="dropdown me-2 pt-3">
                    <div className="input-blocks">
                      <i data-feather="check-circle" className="info-img" />
                      <Select
                        showSearch
                        labelInValue
                        placeholder="Select PayPeriod"
                        value={selectedPayPeriod}
                        onChange={(option) => setSelectedPayPeriod(option)}
                        options={PayperiodOptions}
                        style={{ width: 170, height: 37 }}
                        filterOption={(input, option) =>
                          option?.label?.toLowerCase().includes(input.toLowerCase())
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive brand-table">
                  {vendorLoading ? (
                    <div className="text-center my-4">
                      <Spin size="large" />
                      <p>Loading data...</p>
                    </div>
                  ) : (
                    <Table
                      columns={Vendorcolumns}
                      dataSource={vendorExpensesData}
                      pgno={true}
                      rowKey="id"
                    />
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        {/* <div
          className="offcanvas offcanvas-end"
          tabIndex={-1}
          id="offcanvasRightViewExpense"
          aria-labelledby="offcanvasRightViewExpenseLabel"
          style={{ minWidth: "38%", maxWidth: "38%" }}
        >
          <div className="offcanvas-header py-3">
            <h4 id="offcanvasRightViewExpenseLabel" className="mb-0">
              View Expense Receivers Details
            </h4>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            />
          </div>

          <hr className="my-1" />

          <div className="offcanvas-body px-4">
            {selectedExpense && (
              <form>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={selectedExpense.employee}
                      disabled
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Mobile</label>
                    <input
                      type="text"
                      className="form-control"
                      value={selectedExpense.mobile}
                      disabled
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">Expense Type</label>
                    <input
                      type="text"
                      className="form-control"
                      value={
                        expenseTypes.find(
                          (e) => e.id === selectedExpense.expenseTypeId
                        )?.name || "N/A"
                      }
                      disabled
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Expense Date</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formatDate(selectedExpense.expenseDate)}
                      disabled
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">Amount (₹)</label>
                    <input
                      type="text"
                      className="form-control"
                      value={`₹${selectedExpense.amount}`}
                      disabled
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Approve Amount (₹)</label>
                    <input
                      type="number"
                      className="form-control"
                      value={approvedAmount}
                      disabled={!isApproveMode}
                      onChange={(e) => setApprovedAmount(e.target.value)}
                    />
                  </div>


                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">Status</label>
                    <input
                      type="text"
                      className="form-control"
                      value={selectedExpense.approved ? "Approved" : "Pending"}
                      disabled
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Paid Date</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formatDate(selectedExpense.PaidDate)}
                      disabled
                    />
                  </div>
                  <label className="form-label">Attachment</label>
                  {selectedExpense.filePath ? (
                    <a
                      href={selectedExpense.filePath}
                      target="_blank"
                      rel="noreferrer"
                      className="d-block"
                    >
                      View Attachment
                    </a>
                  ) : (
                    <input
                      type="text"
                      className="form-control"
                      value="No file uploaded"
                      disabled
                    />
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">Notes</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    value={selectedExpense.notes}
                    disabled
                  />
                </div>
                <div className="d-flex justify-content-end gap-2 mt-4">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="offcanvas"
                  >
                    Close
                  </button>

                  {isApproveMode && (
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={handleApproveSubmit}
                    >
                      Approve & Save
                    </button>
                  )}
                </div>
              </form>
            )}
          </div>
        </div> */}

        <div
  className="offcanvas offcanvas-end"
  tabIndex={-1}
  id="offcanvasRightViewExpense"
  aria-labelledby="offcanvasRightViewExpenseLabel"
  style={{ minWidth: "38%", maxWidth: "38%" }}
>
  <div className="offcanvas-header py-3">
    <h4 id="offcanvasRightViewExpenseLabel" className="mb-0">
      {approveMode ? "Approve Expense" : "View Expense"}
    </h4>
    <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" />
  </div>
  <hr className="my-1" />
  <div className="offcanvas-body px-4">
    {selectedExpense && (
      <div>
        {/* Name & Mobile */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">{selectedExpense.employee ? "Employee Name" : "Vendor Name"}</label>
            <input
              type="text"
              className="form-control"
              value={selectedExpense.employee || selectedExpense.vendorName || "N/A"}
              disabled
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Mobile</label>
            <input type="text" className="form-control" value={selectedExpense.mobile || "N/A"} disabled />
          </div>
        </div>

        {/* Type & Date */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Expense Type</label>
            <input
              type="text"
              className="form-control"
              value={
                expenseTypes.find(e => e.id === (selectedExpense.expenseTypeId || selectedExpense.expenseType))?.name ||
                "N/A"
              }
              disabled
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Expense Date</label>
            <input
              type="text"
              className="form-control"
              value={formatDate(selectedExpense.expenseDate || selectedExpense.date)}
              disabled
            />
          </div>
        </div>

        {/* Amounts */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Requested Amount (₹)</label>
            <input
              type="text"
              className="form-control"
              value={`₹${(selectedExpense.amount || 0).toLocaleString("en-IN")}`}
              disabled
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Approved Amount (₹) {approveMode && "*"}</label>
            <input
              type="number"
              className="form-control"
              value={approvedAmount}
              disabled={!approveMode}
              onChange={(e) => setApprovedAmount(e.target.value)}
              placeholder={approveMode ? "Enter approved amount" : ""}
            />
          </div>
        </div>

        {/* Paid Date & Status */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Paid Date</label>
            <input
              type="text"
              className="form-control"
              value={formatDate(selectedExpense.PaidDate || selectedExpense.PaidDateFm)}
              disabled
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Status</label>
            <input
              type="text"
              className="form-control"
              value={(selectedExpense.approved || selectedExpense.isapproved) ? "Approved" : "Pending"}
              disabled
            />
          </div>
        </div>

        {/* Attachment */}
        <div className="mb-3">
          <label className="form-label">Attachment</label>
          {selectedExpense.filePath ? (
            <a href={selectedExpense.filePath} target="_blank" rel="noreferrer" className="d-block text-info">
              View / Download Attachment
            </a>
          ) : (
            <input type="text" className="form-control" value="No file uploaded" disabled />
          )}
        </div>

        {/* Notes */}
        <div className="mb-3">
          <label className="form-label">Notes</label>
          <textarea
            className="form-control"
            rows="3"
            value={selectedExpense.notes || ""}
            disabled
          />
        </div>

        {/* Buttons */}
        <div className="d-flex justify-content-end gap-2 mt-4">
          <button type="button" className="btn btn-secondary" data-bs-dismiss="offcanvas">
            Close
          </button>

          {approveMode && (
            <button
              type="button"
              className="btn btn-success"
              onClick={() => handleApproveSubmit(selectedExpense)}
              disabled={isSubmitting || !approvedAmount.trim() || Number(approvedAmount) <= 0}
            >
              {isSubmitting ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" />
                  Approving...
                </>
              ) : (
                "Approve & Save"
              )}
            </button>
          )}
        </div>
      </div>
    )}
  </div>
</div>

        <div
          className="offcanvas offcanvas-end"
          tabIndex={-1}
          id="offcanvasRightAddPayment"
          aria-labelledby="offcanvasRightLabel"
          style={{ minWidth: "38%", maxWidth: "38%" }}
        >
          <div className="offcanvas-header my-0 py-3">
            <h4 id="offcanvasRightLabel" className="mb-0">
              Add Expense Receiver
            </h4>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            />
          </div>

          <hr className="my-1" />

          <div className="offcanvas-body px-4">
            <form onSubmit={handleAddExpense}>
              {/* <div className="mb-3" style={{ width: "50%" }}>
                <label className="form-label">Receiver Type</label>
                <select
                  className="form-select"
                  value={receiverType}
                  onChange={(e) => setReceiverType(e.target.value)}
                >
                  <option value="employee">Employee</option>
                  <option value="vendor">Vendor</option>
                </select>
              </div> */}

              {/* Employee Form */}
              {receiverType === "employee" && (
                <>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">Branch</label>
                      <Select
                        showSearch
                        placeholder="Select Branch"
                        value={addBranchId}
                        onChange={(val) => setAddBranchId(val)}
                        options={addBranchesOptions}
                        style={{ width: "100%" }}
                        filterOption={(input, option) =>
                          option?.label?.toLowerCase().includes(input.toLowerCase())
                        }
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Department</label>
                      <Select
                        showSearch
                        placeholder="Select Department"
                        value={addDeptId}
                        onChange={(val) => setAddDeptId(val)}
                        options={addDeptOptions}
                        style={{ width: "100%" }}
                        filterOption={(input, option) =>
                          option?.label?.toLowerCase().includes(input.toLowerCase())
                        }
                      />
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">Employee Name</label>
                      <Select
                        showSearch
                        placeholder="Select Employee"
                        value={addEmployeeId}
                        onChange={(val) => setAddEmployeeId(val)}
                        options={addEmpOptions}
                        style={{ width: "100%" }}
                        filterOption={(input, option) =>
                          option?.label?.toLowerCase().includes(input.toLowerCase())
                        }
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Expense Type</label>
                      <select
                        className="form-select"
                        value={expenseType}
                        onChange={(e) => setExpenseType(e.target.value)}
                      >
                        <option value="">Select Expense Type</option>
                        {expenseTypes.map((exp) => (
                          <option key={exp.id} value={exp.id}>
                            {exp.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-3">

                    <div className="col-md-6">
                      <label className="form-label">Expense Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={expenseDate}
                        onChange={(e) => setExpenseDate(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Amount</label>
                      <input
                        type="number"
                        className="form-control"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        placeholder="Enter amount"
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">Paid Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={PaidDate}
                        onChange={(e) => setPaidDate(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Upload Bill / Receipt</label>
                      <input
                        type="file"
                        className="form-control"
                        accept=".jpg,.jpeg,.png,.pdf"
                        onChange={(e) => setAttachment(e.target.files[0])}
                      />
                      <small className="text-muted">
                        Allowed formats: JPG, PNG, PDF
                      </small>
                    </div>
                  </div>
                </>
              )}

              {/* Vendor Form */}
              {receiverType === "vendor" && (
                <>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">Vendor Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={vendorName}
                        onChange={(e) => setVendorName(e.target.value)}
                        placeholder="Enter vendor name"
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Vendor Code</label>
                      <input
                        type="text"
                        className="form-control"
                        value={vendorCode}
                        onChange={(e) => setVendorCode(e.target.value)}
                        placeholder="Enter vendor code"
                      />
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">Mobile</label>
                      <input
                        type="tel"
                        className="form-control"
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        placeholder="Enter mobile number"
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Expense Type</label>
                      <select
                        className="form-select"
                        value={expenseType}
                        onChange={(e) => setExpenseType(e.target.value)}
                      >
                        <option value="">Select Expense Type</option>
                        {expenseTypes.map((exp) => (
                          <option key={exp.id} value={exp.id}>
                            {exp.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">Expense Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={expenseDate}
                        onChange={(e) => setExpenseDate(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Amount</label>
                      <input
                        type="number"
                        className="form-control"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        placeholder="Enter amount"
                      />
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">Paid Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={PaidDate}
                        onChange={(e) => setPaidDate(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Upload Bill / Receipt</label>
                      <input
                        type="file"
                        className="form-control"
                        accept=".jpg,.jpeg,.png,.pdf"
                        onChange={(e) => setAttachment(e.target.files[0])}
                      />
                      <small className="text-muted">
                        Allowed formats: JPG, PNG, PDF
                      </small>
                    </div>
                  </div>
                </>
              )}

              {/* Common Notes / Address */}
              <div className="mb-3">
                <label className="form-label">Address / Notes</label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  placeholder="Enter address or payment notes"
                />
              </div>

              {/* Action Buttons */}
              <div className="d-flex justify-content-end gap-2 mt-4">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="offcanvas"
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  {isSubmitting ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      />
                      Saving...
                    </>
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
        <CommonFooter />
      </div>
    </div>
  );
};

export default PayList;